<script setup>
import { Link } from '@inertiajs/vue3'
import pluralize from "pluralize";
import TopicIcon from "../Library/TopicIcon.vue";
import ClockSvg from '@svg/new-clock.svg'

defineProps({
    path: Object,
    showType: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <Link :href="`/paths/${path.slug}`" class="bg-[rgba(20,22,57,1)] h-[360px] rounded-3xl p-9 pb-6 flex flex-col relative after:w-full after:left-0 after:absolute after:h-16 after:pointer-events-none after:bottom-6 after:bg-gradient-to-t after:from-[rgba(20,22,57,1)]">
        <div v-if="showType" class="bg-[rgba(27,32,74,1)] text-[rgba(148,162,209,1)] font-semibold absolute -top-1.5 -right-1.5 rounded-xl px-3.5 py-2 leading-none text-xs">
            Path
        </div>

        <div>
            <div class="flex items-center space-x-3">
                <div class="size-[40px] bg-[rgba(34,36,81,1)] rounded-xl flex items-center justify-center">
                    <TopicIcon :slug="path.topic.slug" class="size-6" />
                </div>
                <h3 class="text-[rgba(233,232,255,1)] text-lg md:text-xl font-semibold line-clamp-2">
                    {{ path.title }}
                </h3>
            </div>
            <p class="text-[rgba(148,162,209,1)] text-xs line-clamp-2 mt-2 leading-normal">
                {{ path.description }}
            </p>
        </div>

        <div class="relative flex items-center space-x-2 mt-3 pb-3 before:absolute before:-bottom-[10px] before:left-[9px] before:h-[2px] before:bg-gradient-to-r before:from-[rgba(147,132,241,0.3)] before:to-[rgba(147,132,241,0)] before:w-full after:absolute after:w-[8px] after:h-[8px] after:bg-[rgba(147,132,241,0.3)] after:-left-0 after:-bottom-[13px] after:rotate-45">
            <div class="rounded-full bg-[rgba(27,32,74,1)] h-8 px-3 flex items-center text-[rgba(148,162,209,1)] text-xs">
                {{ pluralize('course', path.courses_count, true) }}
            </div>
            <div class="rounded-full bg-[rgba(27,32,74,1)] h-8 px-3 flex items-center text-[rgba(148,162,209,1)] text-xs space-x-2">
                <ClockSvg class="size-4 mr-1" />
                <template v-if="path.duration.formatted.hours">{{ path.duration.formatted.hours }} {{ pluralize('hr', path.duration.formatted.hours) }} </template> {{ path.duration.formatted.minutes }} {{ pluralize('min', path.duration.formatted.minutes) }}
            </div>
        </div>

        <div class="relative grow overflow-y-scroll mt-4 space-y-2 py-2 px-1 pb-10">
            <div class="flex items-center space-x-3" v-for="(course, index) in path.courses" :key="course.id">
                <div class="text-xs font-semibold text-[rgba(148,162,209,1)] leading-none size-[30px] min-w-[30px] flex items-center justify-center rounded-full border border-[rgba(43,57,100,1)]">{{ index + 1 }}</div>
                <div class="text-xs text-[rgba(148,162,209,1)] font-medium">{{ course.title }}</div>
            </div>
        </div>
    </Link>
</template>
